const vehicleDataAction = (payload) => {
  return {
    type: "atual-vehicle-data",
    payload
  }
}
export default vehicleDataAction;